import Util from '../../util/common'
import * as types from '../types'
const state = {
  token:null
}

const mutations = {
  [types.CHANGE_TOKEN] (state,res) {
    state.token = res
  }
}


export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/login.js